export const corporateIdIsInvalid = (corporateId: string) => {
  return (
    corporateId.includes("http") ||
    corporateId.includes("g.page") ||
    corporateId.includes(".com") ||
    corporateId.includes("writeareview") ||
    corporateId.includes("/review")
  );
};
